import { Box, Chip, Stack, Typography } from '@mui/material'
import { useMemo } from 'react'
import { getAuthState, selectors } from '@/features/auth/slice'
import { useAppSelector } from '@/redux/hooks'

export const JwtDebugSection = () => {
  const { token } = useAppSelector(getAuthState)
  const tokenData = useAppSelector(selectors.selectUserTokenData)

  const sizes = useMemo(() => {
    if (!token) return null
    const authHeader = new TextEncoder().encode(`Bearer ${token}`).length
    const cookies = new TextEncoder().encode(document.cookie).length
    return { authHeader, cookies, total: authHeader + cookies }
  }, [token])

  if (!token || !tokenData) {
    return (
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          JWT Token
        </Typography>
        <Typography variant="body2" color="text.secondary">
          No token available
        </Typography>
      </Box>
    )
  }

  const warningThreshold = 8 * 1024
  const dangerThreshold = 14 * 1024

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        JWT Token
      </Typography>

      <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 1 }}>
        <Chip
          label={`Auth header: ${sizes?.authHeader} bytes`}
          size="small"
          variant="outlined"
        />
        <Chip
          label={`Cookies: ${sizes?.cookies} bytes`}
          size="small"
          variant="outlined"
        />
        <Chip
          label={`Combined: ${sizes?.total} bytes`}
          size="small"
          color={
            (sizes?.total ?? 0) > dangerThreshold
              ? 'error'
              : (sizes?.total ?? 0) > warningThreshold
                ? 'warning'
                : 'success'
          }
        />
      </Stack>

      <Box
        component="pre"
        sx={{
          fontSize: 11,
          maxHeight: 300,
          overflow: 'auto',
          bgcolor: 'grey.100',
          p: 1,
          borderRadius: 1,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
        }}
      >
        {JSON.stringify(tokenData, null, 2)}
      </Box>
    </Box>
  )
}
